import { S999gS999m01Component } from './s999g-s999m01.component';

export { S999gModule } from './s999g.module';

export const S999gSubComponentsMap = {
	
};

export const S999gComponentsMap = {
	"s999g-s999m01": S999gS999m01Component
};

export const S999gComponents = [
	S999gS999m01Component
];

